<template>
  <v-card title="Team Lead">
    <template v-slot:append>
      <v-icon icon="mdi-account-plus" @click="openModal('addTeamLeader')"></v-icon>
      <v-tooltip activator="parent" location="end">Update Team Leader</v-tooltip>
    </template>
    <v-card-text>
      <v-row>
        <v-col>
          <v-list v-if="teamLeader">
            <v-list-item :prepend-avatar="blankProfileUrl">
              <v-list-item-title
                ><router-link
                  v-if="teamLeader.id"
                  :to="{ name: 'AdminUserEditDetail', params: { id: teamLeader.id } }"
                  >{{ teamLeader.first_name }} {{ teamLeader.last_name }}</router-link
                ></v-list-item-title
              >
              <v-list-item-subtitle>{{ teamLeader.email_address }}</v-list-item-subtitle>
            </v-list-item>
            <v-list-item>Phone: {{ teamLeader.phone_number }}</v-list-item>
            <v-list-item
              >Address:
              <v-row
                ><v-col
                  >{{ teamLeader.street_address }} <br />
                  {{ teamLeader.city }}, {{ teamLeader.state }} {{ teamLeader.postal_code }} <br />
                  {{ teamLeader.country }}</v-col
                ></v-row
              >
            </v-list-item>
          </v-list>
        </v-col>
        <v-col>
          <v-col cols="auto" class="d-flex flex-column align-center justify-center">
            <v-avatar v-if="teamLeader && teamLeader.is_under_18" size="125">
              <v-icon icon="mdi-account-child-circle" size="80" color="red"></v-icon>
            </v-avatar>
          </v-col>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>

  <v-dialog v-model="isTeamLeadModalOpen" max-width="700px">
    <v-card>
      <v-card-title>Update Team Lead</v-card-title>
      <v-card-text>
        <v-data-table-server
          v-model="possibleTeamLeaders.selected"
          select-strategy="single"
          show-select
          :items="possibleTeamLeaders.data"
          :headers="possibleTeamLeaders.headers"
          :items-per-page="possibleTeamLeaders.pageOptions.limit"
          item-key="id"
          :items-length="possibleTeamLeaders.count"
          :search="possibleTeamLeaders.pageOptions.q"
          @update:options="handleLimitChange">
          <template v-slot:top>
            <v-text-field
              v-model="possibleTeamLeaders.pageOptions.q"
              class="ma-2"
              density="compact"
              placeholder="Search team leader..."
              hide-details></v-text-field>
          </template>
        </v-data-table-server>
      </v-card-text>
      <v-card-actions>
        <v-btn color="secondary" @click="isTeamLeadModalOpen = false">Cancel</v-btn>
        <v-btn color="primary" @click="updateTeamLeader">Update</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script setup lang="ts">
import { IPaginationDTO, IUserDTO, PaginationDTO, UserDTO } from '@/dtos';
import { ref, toRef, watch } from 'vue';
import blankProfileUrl from '@/assets/blankProfile.webp';
import { getPossibleUsers, updateTeamLead } from '@/controllers/admin';
import type { VDataTableServer } from 'vuetify/components';
import { useTeamStore } from '@/stores';

interface Props {
  yearId: string;
  teamId: string;
}
const props = defineProps<Props>();
//const emit = defineEmits(['updateBranchYear']);
const yearId = toRef(props, 'yearId', '');
const teamId = toRef(props, 'teamId', '');
const isTeamLeadModalOpen = ref<boolean>(false);
const teamLeader = ref<IUserDTO>(new UserDTO());
const teamStore = useTeamStore();

const { data, isLoading } = teamStore.getTeamLeadQuery(teamId, yearId);

watch(
  () => isLoading.value,
  () => {
    teamLeader.value = new UserDTO(data.value);
  },
);

const possibleTeamLeaders = ref({
  pageOptions: new PaginationDTO() as IPaginationDTO,
  count: 0,
  data: [] as IUserDTO[],
  loading: false,
  selected: [] as string[],
  headers: [
    { title: 'First Name', key: 'first_name', align: 'start', sortable: true },
    { title: 'Last Name', key: 'last_name', align: 'start', sortable: true },
    { title: 'Email', key: 'email_address', align: undefined, sortable: true },
    { title: '', key: 'action', align: 'end', sortable: false },
  ] as const,
});

const fetchPossibleUsers = async () => {
  try {
    possibleTeamLeaders.value.loading = true;
    const teamsData = await getPossibleUsers(possibleTeamLeaders.value.pageOptions);
    possibleTeamLeaders.value.data = teamsData.data;
    possibleTeamLeaders.value.count = teamsData.count;
  } catch (error) {
    console.error('Error fetching teams:', error);
  } finally {
    possibleTeamLeaders.value.loading = false;
  }
};

const handleLimitChange = async (value: VDataTableServer) => {
  possibleTeamLeaders.value.pageOptions.buildPagination(value);
  await fetchPossibleUsers();
};
const updateTeamLeader = async () => {
  try {
    const returnObj = await updateTeamLead(
      teamId.value,
      yearId.value,
      possibleTeamLeaders.value.selected[0],
      true,
    );
    teamLeader.value = returnObj as UserDTO;
    possibleTeamLeaders.value.data = [];
    isTeamLeadModalOpen.value = false;
  } catch {
    //TODO: do something with error
  }
};

const openModal = (type: string) => {
  if (type === 'addTeamLeader') {
    possibleTeamLeaders.value.selected[0] = teamLeader.value.id;
    fetchPossibleUsers();
    isTeamLeadModalOpen.value = true;
  }
};
</script>

<!-- TODO
1. Fix under 18
-->
